import { ClinicDao } from "fe-common/graphql/dao";
import { ClinicDaoData } from "./clinicProvider";

export async function getClinicDataFromServer(
  dao: ClinicDao,
  clinicId: string,
): Promise<ClinicDaoData> {
  if (!clinicId) {
    return {
      clinic: clinicId,
      error: true,
      errorText: "Not a valid clinic", //TODO - need real error handling!
    };
  }
  try {
    const result = await dao.getClinicConfig(clinicId);
    if (result?.deleted)
      return { error: true, errorText: "clinic disabled", clinic: clinicId };
    if (result) {
      return {
        error: false,
        ...result,
        clinic: clinicId,
      };
    }
  } catch (e) {
    console.error(e, "error retrieving clinic information");
    return { error: true, errorText: e, clinic: clinicId };
  }
}
